import React, { useEffect, useState, useRef } from "react";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import VirtualTable from "../ui/VirtualTable";
import { ROUTES } from "../utils/Routes";
import { createModal } from "../hooks/createModal";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { bm_date } from "../utils/Utils";
import Nav from "../ui/Nav";
import OrderTitleSelector from "../popups/OrderTitleSelector";

export default function InvoiceSelect(props) {

    const { callback = () => {}, route = "", controller = "", signal = {}, initialData = [], value = "" } = props;

    const [ data, setData ] = useState(initialData.rows || []);
    const [ selected, setSelected ] = useState((initialData.rows || [])[0] || {});
    const [ loading, setLoading ] = useState(false);
    const offsetRef = useRef(100);

    const loadMore = () => {
        if (offsetRef.current >= initialData.total) return;
        if (loading) return;
        setLoading(true);
        pubCall("order.getInvoiceSupplierOptions", { supplier: value, limit: 100, offset: offsetRef.current }, (_s, _r) => {
            if (_s) {
                setData(prev => [...prev, ..._r.rows]);
                offsetRef.current += 100;
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const generateKey = () => {
        return `${Math.random().toString(36).substr(2, 9)}`;
    };

    const columns = [
        { key: "invoice", align: "left", title: <>Invoice#</>, width: 100 },
        { key: "invoice_date", align: "left", title: <>InvDate</>, width: 100, render: (e) => {
            return <span style={{"fontFamily" : "var(--font-mono)"}}>{bm_date(e)}</span>
        } },
        { key: "po_number", align: "left", title: <>PO#</>, width: 100 },
        { key: "status", align: "left", title: <>Stat</>, width: 70 },
        { key: "status_date", align: "left", title: <>StatDate</>, width: 150, render: (e) => {
            return <span style={{"fontFamily" : "var(--font-mono)"}}>{bm_date(e)}</span>
        } },
    ]

    const viewOrderItems = (invoice) => {
        window.bm_state.value = ROUTES.HELPERS.INVOICE_TITLE_SELECTOR;
        pubCall("order.getInvoiceTitleOptions", { invoice_num: invoice }, (_s, _r) => {
            if (_s) {
                const dataWithKeys = {
                    ..._r,
                    rows: _r.rows?.map(row => ({ ...row, key: generateKey() })) || []
                };
                createModal({
                    title: `Items in Orders on Inv#${selected?.invoice} ${bm_date(selected?.invoice_date)}`,
                    closable: true,
                    component: <OrderTitleSelector
                        route={ROUTES.HELPERS.INVOICE_TITLE_SELECTOR}
                        value={selected?.invoice}
                        initialData={dataWithKeys}
                    />,
                    callback: (value) => {
                        if (value) {
                            callback(value);
                            window.bm_state.value = ROUTES.ORDERS.SEARCH;
                        } else {
                            window.bm_state.value = ROUTES.HELPERS.INVOICE_SELECTOR;
                        }
                    }
                })
            } else {
                showError(_r);
            }
        })
    }

    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const currentIndex = data.findIndex(item => item?.invoice === selected?.invoice);
        const nextIndex = currentIndex + _rows;
        
        if (nextIndex >= data.length - 5 && !loading) {
            loadMore();
        }
        
        if (data.length <= nextIndex) { setSelected(data[0]);}
        if (nextIndex < data.length) { setSelected(data[nextIndex]);}
    };

    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.invoice === selected?.invoice) - _rows;
        if (prevIndex < 0) { setSelected(data[0]); return;}
        if (prevIndex >= 0) { setSelected(data[prevIndex]);}    
    };

    const nav = [
        { key: KBD.ESCAPE, action: () => callback("search") },
        { key: KBD.ARROW_DOWN, action: () => next() },
        { key: KBD.ARROW_UP, action: () => prev() },
        { key: KBD.ENTER, text: "Enter",action: () => viewOrderItems(selected?.invoice) },
    ]

    useEffect(() => {
        const cleanup = listen(controller, route, nav, false, [KBD.ESCAPE, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ENTER, KBD.PAGE_DOWN]);
        return cleanup;
    }, [selected, data])


    return (
        <>
            <VirtualTable
                controller={controller}
                row_key={"invoice"}
                next={next}
                prev={prev}
                route={route}
                current={selected}
                data={data}
                width={520}
                height={320}
                offset={0}
                columns={columns}
                />
            <div className="shim"/><div className="shim"/>
            <Nav nav={nav} />
        </>
    )
}